import styled from 'styled-components'

import { Button, ButtonUnstyled, PillProps, Pill } from '@sketch/components'

import Panel from '../Panel'

import { breakpoint } from '@sketch/global-styles'

export const CanceledPill = styled(Pill).attrs<PillProps>({
  color: 'red',
  variant: { kind: 'primary' },
})`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const BlockText = styled.span`
  display: block;
`

export const HeaderButton = styled(Button)`
  transition: none;
`

export const StyledPanelTitle = styled(Panel.Title)`
  display: flex;

  ${breakpoint('base', 'xs')`
    flex-direction: column;
    align-items: flex-start;
  `}

  /* Hack to fix the Button presentation in IE11 */
  & ${ButtonUnstyled} {
    flex-shrink: 0;
    display: inline;
  }
`
